import { render } from "./component-code.vue?vue&type=template&id=83f2d0cc"
import script from "./component-code.vue?vue&type=script&setup=true&lang=js"
export * from "./component-code.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-code.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "83f2d0cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('83f2d0cc', __exports__)) {
    api.reload('83f2d0cc', __exports__)
  }
  
  module.hot.accept("./component-code.vue?vue&type=template&id=83f2d0cc", () => {
    api.rerender('83f2d0cc', render)
  })

}


export default __exports__